<div class="alert alert-danger" role="alert" *ngIf="error" [ngClass]="ngClass">
  <div *ngIf="errorType == 'string'">
    {{error}}
  </div>
  <div *ngIf="httpError">
    <h3>{{httpError.status}}. {{httpError.statusText}}</h3>
    <div *ngIf="httpError.url">
      Failure to get response from <a target="_blank" [href]="httpError.url">{{httpError.url}}</a>
    </div>
    <div *ngIf="httpError['error']['reason']">
      {{httpError['error']['reason'] | json}}
    </div>
    <div *ngIf="httpError['error']" class="m-0 p-0 pt-1">
      <ul class="overflow-auto">
        <li *ngIf="hasUserInfo && userInfo['errorCode']" class="pt-1">
          Error code:
          <span class="font-monospace">{{userInfo['errorCode']}}</span>
        </li>
        <li *ngIf="hasUserInfo && userInfo['errorDescription']" class="pt-1">
          Error description:
          <span class="font-monospace">{{userInfo['errorDescription']}}</span>
        </li>
        <li *ngIf="httpError['error']['exceptionType']" class="pt-1">
          [DEBUG] Error type:
          <span class="font-monospace">{{httpError['error']['exceptionType']}}</span>
        </li>
        <li *ngIf="hasStackTrace" class="pt-1">
          [DEBUG] Stack Trace (<a
          (click)="expandedStackTrace = !expandedStackTrace"
        >{{expandedStackTrace ? 'Hide' : 'Show'}}</a>):
          <div class="bg-body-tertiary" *ngIf="expandedStackTrace"><pre>{{httpError['error']['stackTrace']}}</pre></div>
        </li>
        <li *ngIf="hasUserInfo" class="pt-1">
          [DEBUG] User Info (<a
          (click)="expandedUserInfo = !expandedUserInfo"
        >{{expandedUserInfo ? 'Hide' : 'Show'}}</a>):
          <div class="bg-body-tertiary" *ngIf="expandedUserInfo"><pre>{{httpError['error']['userInfo'] | json}}</pre></div>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="!httpError">
    <h3 *ngIf="errorHeading">{{errorHeading}}</h3>
    {{error | json}}
  </div>
</div>
